import actionSVG from "../../../images/nav/actions.svg";
import ActionCardNoInteraction from "../../action/ActionCardNoInteraction";
import React from "react";
import styled from "styled-components";
import {useSelector} from "react-redux";

const ActionsByProjectContainer = () => {

    const {actions} = useSelector(state => state.project)

    const displayActions = () => {
        if (actions.length > 0) {
            return (
                actions.map((a, index) => (
                    <ActionCardNoInteraction
                        key={index}
                        picture={a.pilot.photo}
                        firstName={a.pilot.firstName}
                        lastName={a.pilot.lastName}
                        actionName={a.name}
                        criticality={a.criticality}
                        deadline={a.deadline}
                        advancement={a.advancement}
                    />
                ))
            )
        } else {
            return (
                <p className={"fw-700 w-100"}> Il n'existe pas encore d'action pour ce projet  </p>
            )
        }
    }
    return (
        <ContainerActions>
            <div className={"flex-row gap-05"}>
                <img src={actionSVG} alt="actions au service du projet "/>
                <h2> Actions au service du projet </h2>
            </div>

            <SecondSection>
                <Wrapper>
                    {displayActions()}
                </Wrapper>
            </SecondSection>

        </ContainerActions>
    )
}

const ContainerActions = styled.div`
  background-color: var(--color-white);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  grid-column-start: 2;
  grid-column-end: 12;
  grid-row-start: 13;
  grid-row-end: 13;
  gap: 1em;
  padding: 1em;
  border-radius: 15px;
  img{
    width: 24px;
    height: auto;
  }

  @media (min-width: 900px) {
    padding-top: 1em;
  }
`

const SecondSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
`

const Wrapper = styled.div`
  display: inherit;
  width: 100%;
  flex-direction: inherit;
  align-items: inherit;
  gap: 1em;
  @media (min-width: 900px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
   justify-content: center;
  }
`
export default ActionsByProjectContainer